
import { Environment,Network,RecordSource,Store } from 'relay-runtime';

const AuthBaseUrl = process.env.REACT_APP_APPLICATION_URL + "/graphql/";
 //const AuthBaseUrl = 'http://127.0.0.1:8000/graphql/';

const fetchGraphQl = async(params,variables) => {
    const response = await fetch(AuthBaseUrl,{
        method:'POST',
        headers:{
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            query : params.text,
            variables
        }),
    });
    return await response.json();
};

const environment = new Environment({
    network: Network.create(fetchGraphQl),
    store: new Store(new RecordSource())
});

export default environment;